import { DataSource, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInboundFuncAck extends Layout {
    labelDirection: Label;
    sourceEdiProfile: DataSource;
    textboxAckAltPartnerId: Textbox;
    textboxAckCommId: Textbox;
    textboxAckNextBatch: Textbox;
    textboxAckPartnerId: Textbox;
    textboxAckPartnerName: Textbox;
    textboxAckTemplate: Textbox;
    textboxAckVersion: Textbox;
}
